import {
    ColorClubMatasPlus3,
    ColorHealth3,
    ColorNordicGrey2,
    ColorSystemPositive5
} from 'autogen/design-tokens/tokens';

type TagType =
    | 'EcoChoice'
    | 'LowCost'
    | 'FastDelivery'
    | 'ExtraPoints'
    | 'LastUsed'
    | 'ClickAndCollect'
    | 'Custom'
    | 'StoreDelivery';

export function getTagStyling(tagType: TagType) {
    switch (tagType) {
        case 'EcoChoice':
            return ColorHealth3;
        case 'ExtraPoints':
            return ColorClubMatasPlus3;
        case 'ClickAndCollect':
            return ColorSystemPositive5;
        case 'FastDelivery':
        case 'LowCost':
        default:
            return ColorNordicGrey2;
    }
}
